import {
  ADULT_DOUBLES_ASSESSMENT,
  ADULT_DOUBLES_START,
  ADULT_LESSONS_START,
  CAMP_REGISTRATION_OPENS,
  CLUB_CHAMPIONSHIPS_FINALS_DATE,
  CLUB_CHAMPIONSHIPS_FINALS_DOUBLES_DATE,
  CLUB_CHAMPIONSHIPS_FINALS_DOUBLES_MIXED_DATE,
  CLUB_CHAMPIONSHIPS_FINALS_DOUBLES_OPEN_DATE,
  CLUB_CHAMPIONSHIPS_FINALS_SINGLES_DATE,
  CLUB_CHAMPIONSHIPS_START,
  ICECREAM_TOUR_DATE,
  INTERURBAN_TRYOUTS,
  JUNIOR_CAMPS_START,
  JUNIOR_CLUB_CHAMPIONSHIPS,
  JUNIOR_FRENCH_OPEN_DATE,
  JUNIOR_LESSONS_START,
  LADDERS_START,
  PARENT_CHILD_TOURN_DATE,
  REGISTRATION_OPENS,
  SEASON_OPENING_FESTIVAL_DATE,
  SEASON_OPENING_MEET_AND_GREET,
  SINGLES_DROPIN_START,
  WIMBLEDON_DATE,
} from '../../constants'

import CalendarMonth from './CalendarMonth'
import GoogleCalendar from './GoogleCalendar'
import { Row } from 'antd'
import Section from '../common/Section'

const entries = {
  april: [
    { date: REGISTRATION_OPENS, label: 'Club registration opens' },
    { date: CAMP_REGISTRATION_OPENS, label: 'Summer camp registration opens' },
    { date: LADDERS_START, label: <>Ladders begin</> },
    { date: 'April 13', label: <>Adult doubles registration</>, note: '' },
    { date: ADULT_DOUBLES_ASSESSMENT, label: <>Adult doubles assessments</>, note: '' },
  ],
  may: [
    { date: SEASON_OPENING_MEET_AND_GREET, label: <>Season Opening Meet &amp; Greet</> },
    { date: 'May 2 and 9', label: <>Free days in May</> },
    // { date: SINGLES_DROPIN_START, label: <>Int/Adv Drop-ins begin</>, note: '' },
    { date: JUNIOR_LESSONS_START, label: <>Junior lessons start</> },
    { date: INTERURBAN_TRYOUTS, label: <>Interurban tryouts</>, note: '' },
    { date: ADULT_DOUBLES_START, label: <>Adult Social Doubles begins</> },
  ],
  june: [
    { date: SEASON_OPENING_FESTIVAL_DATE, label: <>Season Opening Tennis Festival</> },
    { date: ADULT_LESSONS_START, label: <>Adult lessons start</> },
    // { date: PARENT_CHILD_TOURN_DATE, label: <>Parent/child tournament</> },
  ],
  july: [
    { date: JUNIOR_CAMPS_START, label: <>Junior camps start</> },
    { date: 'June 29-Aug 6', label: <>Swing &amp; Splash camp (Tues &amp; Thurs)</> },
    { date: WIMBLEDON_DATE, label: <>Wimbledon Social</> },
    { date: WIMBLEDON_DATE, label: <>Hespeler Reunion</> },
    { date: ICECREAM_TOUR_DATE, label: <>Ice Cream Tournament</> },
    { date: 'July 26', label: <>Multicultural Festival</> },
  ],
  aug: [
    { date: CLUB_CHAMPIONSHIPS_FINALS_SINGLES_DATE, label: <>Club Championships - Singles</> },
    { date: CLUB_CHAMPIONSHIPS_FINALS_DOUBLES_OPEN_DATE, label: <>Club Championships - Open/Ladies Doubles</> },
  ],
  sept: [
    { date: JUNIOR_CLUB_CHAMPIONSHIPS, label: <>Junior Club Championships</> },
    { date: CLUB_CHAMPIONSHIPS_FINALS_DOUBLES_MIXED_DATE, label: <>Club Championships - Mixed Doubles</> },
  ],
}

const CalendarPage = () => {
  return (
    <>
      <Section title="Calendar">
        <Row gutter={10} style={{ marginTop: '2em' }}>
          <CalendarMonth monthName="April" entries={entries.april} />
          <CalendarMonth monthName="May" entries={entries.may} />
          <CalendarMonth monthName="June" entries={entries.june} />
          <CalendarMonth monthName="July" entries={entries.july} />
          <CalendarMonth monthName="August" entries={entries.aug} />
          <CalendarMonth monthName="September" entries={entries.sept} />
        </Row>
      </Section>

      {/* <GoogleCalendar /> */}
    </>
  )
}

export default CalendarPage
